export default __webpack_public_path__ + "static/media/32_mobile.7c3248ef.jpg";